import { Component, OnInit } from '@angular/core';
import { DriverService } from '../driver.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-driver-info',
  templateUrl: './driver-info.component.html',
  styleUrls: ['./driver-info.component.scss']
})
export class DriverInfoComponent implements OnInit {
  driverDetail: any = [];
  pic: string;
  id: number;
  constructor(
    private driverService: DriverService,
    private route: ActivatedRoute
  ) {
    this.id = this.route.snapshot.params['Id'];

   }

  ngOnInit() {
    this.getdriverDetail();
  }
  getdriverDetail() {
    this.driverService.getDriverbyId(this.id).subscribe(Response => {
      this.driverDetail = Response;
      this.pic = 'https://www.foodizza.com//' + Response.ImageUrl;
      console.log('this pic response,,', this.pic);
      console.log('driver detail with Id', this.driverDetail);
    });
  }
}
